// UI string translations. To add a new language later (e.g. Swahili "sw"),
// add a matching object below and register the code in LanguageContext.
export const STRINGS = {
  en: {
    brand: "Maqam Journey",
    beginJourney: "Begin Your Journey",
    "hero.welcome": "Welcome to Your",
    "hero.brand": "Maqam Journey",
    latestUpdates: "Latest Updates",
    checkHere: "Check here first before asking on WhatsApp — new updates always appear here.",
    exploreJourney: "Your Journey",
    exploreSubtitle: "Everything you need, in one place.",
    back: "Back",
    backToJourney: "Back to Journey",
    viewOnMaps: "Directions",
    call: "Call",
    whatsapp: "WhatsApp",
    open: "Open",
    download: "Download",
    noFileYet: "Coming soon",
    walkingDistance: "Walk to Haram",
    checkInInfo: "Check-in",
    amenities: "Nearby amenities",
    viewDetails: "View",
    // nav
    "nav.home": "Home",
    "nav.itinerary": "Itinerary",
    "nav.documents": "Documents",
    "nav.updates": "Updates",
    "nav.support": "Support",
    "nav.maps": "Maps",
    "nav.more": "More",
    "more.title": "More",
    "more.subtitle": "All your journey essentials",
    "today.title": "Today's Journey",
    "today.day": "Day",
    "today.before": "Your journey hasn't started yet",
    "today.after": "Your journey is complete",
    // emergency SOS
    "sos.title": "Emergency SOS",
    "sos.hold": "Press & hold for 3 seconds",
    "sos.holding": "Keep holding…",
    "sos.ready": "Emergency options ready",
    "sos.callEmergency": "Call Maqam Emergency",
    "sos.whatsappEmergency": "WhatsApp Emergency",
    "sos.shareLocation": "Share My Location",
    "sos.guidance": "Emergency Guidance",
    "sos.lost": "Lost from the group",
    "sos.lostBody": "Stay where you are if it is safe. Message the Maqam WhatsApp group so a nearby member can help, keep your hotel card visible, and call your Group Leader or Maqam support.",
    "sos.medical": "Medical emergency",
    "sos.medicalBody": "Call 997 (Red Crescent), 911 (unified emergency) or 937 (Ministry of Health), then notify the Maqam team immediately.",
    "sos.passport": "Passport issues",
    "sos.passportBody": "Contact the Maqam team right away; keep a photo of your passport handy.",
    "sos.transport": "Transportation problems",
    "sos.transportBody": "Call your Group Leader and wait in a safe, visible location.",
    "sos.reset": "Reset",
    // install prompt
    "install.title": "Install Maqam Journey",
    "install.body": "Add it to your home screen for quick, app-like access throughout your trip.",
    "install.cta": "Install",
    "install.later": "Not now",
    // priority labels
    "priority.important": "Important",
    "priority.reminder": "Reminder",
    "priority.action": "Action Required",
    "priority.completed": "Completed",
    "priority.new": "New",
    "priority.travel": "Travel Update",
    // trip status
    "status.draftTitle": "Being Prepared",
    "status.archivedTitle": "Journey Concluded",
    "status.future": "Please check back soon for future Maqam journeys.",
    // section titles
    "sec.travel.title": "Travel Details",
    "sec.travel.desc": "Flights, airports & arrival",
    "sec.hotels.title": "Hotels",
    "sec.hotels.desc": "Your Madinah & Makkah stays",
    "sec.itinerary.title": "Daily Itinerary",
    "sec.itinerary.desc": "Your day-by-day schedule",
    "sec.umrah.title": "Umrah Guide",
    "sec.umrah.desc": "Step-by-step guide & du'a",
    "sec.documents.title": "Documents",
    "sec.documents.desc": "Tickets, visa & checklists",
    "sec.maps.title": "Maps & Navigation",
    "sec.maps.desc": "Hotels, meeting & pickup points",
    "sec.food.title": "Food & Shopping",
    "sec.food.desc": "Essentials near your hotels",
    "sec.faq.title": "FAQ",
    "sec.faq.desc": "Quick answers to common questions",
    "sec.support.title": "Support",
    "sec.support.desc": "Contacts & emergency help",
    "sec.guide.title": "Digital Umrah Guide",
    "sec.guide.desc": "Read, track Tawaf & Sa'i",
    "sec.flights.title": "Flight Itinerary",
    "sec.flights.desc": "EgyptAir — outbound & return",
    // digital umrah guide
    "guide.title": "Digital Umrah Guide",
    "guide.subtitle": "Your calm, step-by-step companion for Umrah.",
    "guide.read": "Read the Guide",
    "guide.readDesc": "Open, browse every page and zoom in",
    "guide.download": "Download Guide",
    "guide.downloadDesc": "Save a copy for offline reference",
    "guide.page": "Page",
    "guide.of": "of",
    "guide.tools": "Interactive Ritual Tools",
    "guide.toolsDesc": "Track your Tawaf, Sa'i and Umrah steps. Progress is saved privately on this device.",
    "guide.reset": "Reset progress",
    "guide.resetTitle": "Reset your progress?",
    "guide.resetBody": "This clears your Tawaf circuits, Sa'i lengths and ritual checklist. This cannot be undone.",
    "guide.cancel": "Cancel",
    // tawaf counter
    "tawaf.title": "Tawaf Counter",
    "tawaf.help": "Tap a circle each time you complete a circuit and return to the Black Stone.",
    "tawaf.circuit": "Circuit",
    "tawaf.completed": "of 7 circuits completed",
    "tawaf.done": "Tawaf complete — 7 circuits. May Allah accept it.",
    // sa'i counter
    "sai.title": "Sa'i Counter",
    "sai.help": "Tap each length as you complete it. Sa'i begins at Safa and finishes at Marwa.",
    "sai.length": "Length",
    "sai.completed": "of 7 lengths completed",
    "sai.finish": "Sa'i finishes at Marwa",
    "sai.done": "Sa'i complete — you finished at Marwa.",
    // ritual checklist
    "checklist.title": "Umrah Ritual Checklist",
    "checklist.help": "Tap each step as you complete it.",
    "checklist.ihram": "Ihram & intention (niyyah)",
    "checklist.tawaf": "Tawaf — seven circuits",
    "checklist.rakahs": "Two rak'ahs after Tawaf",
    "checklist.zamzam": "Drink Zamzam water",
    "checklist.sai": "Sa'i — seven lengths",
    "checklist.hair": "Cutting the hair (halq / taqsir)",
    "checklist.hairNote": "Your Umrah completes once you cut your hair.",
    "checklist.complete": "Umrah complete — may Allah accept it.",
    // flight itinerary
    "flights.title": "Flight Itinerary",
    "flights.subtitle": "Your EgyptAir flights, at a glance.",
    "flights.outbound": "Outbound",
    "flights.return": "Return",
    "flights.depart": "Departs",
    "flights.arrive": "Arrives",
    "flights.nextDay": "Next day",
    "flights.flight": "Flight",
    "flights.localTimes": "All times are local to each airport.",
    "itinerary.preTrip": "Before You Travel",
    "flights.airportMeet": "Airport meeting point",
    "worship.title": "Make the Most of Your Free Time",
    "travel.departures": "Departure Instructions",
    "maps.laundry": "Recommended Laundry Services",
    "sec.janazah.title": "Salatul Janazah",
    "sec.janazah.desc": "The funeral prayer, step by step",
    "janazah.title": "Salatul Janazah (Funeral Prayer)",
    "janazah.open": "Salatul Janazah Guide",
    "food.restaurants": "Restaurants (Google Maps list)",
    "food.cafes": "Cafés (Google Maps list)",
    "prayer.title": "Prayer Times",
    "prayer.madinah": "Madinah",
    "prayer.makkah": "Makkah",
    "prayer.madinahTitle": "Madinah Prayer Times",
    "prayer.makkahTitle": "Makkah Prayer Times",
    "prayer.method": "Umm al-Qura · Saudi time",
    "prayer.fajr": "Fajr",
    "prayer.sunrise": "Sunrise",
    "prayer.dhuhr": "Dhuhr",
    "prayer.asr": "Asr",
    "prayer.maghrib": "Maghrib",
    "prayer.isha": "Isha",
    "prayer.next": "Next",
    "prayer.in": "in",
    "prayer.updated": "Last updated",
    "prayer.error": "Prayer times are temporarily unavailable. Please check your connection and try again.",
    "prayer.retry": "Retry",
    // admin
    "umrah.steps": "Step-by-Step Guide",
    "umrah.checklist": "Ihram Checklist",
    "umrah.dos": "Do's",
    "umrah.donts": "Don'ts",
    "umrah.dua": "Digital Du'a Guide",
    // support
    "support.contacts": "Key Contacts",
    "support.emergency": "Emergency Numbers",
    "support.lost": "If You Get Separated",
    // documents
    "documents.reminders": "Important Travel Documents & Reminders",
    // journey progress (auto)
    "progress.before": "Preparing for Your Journey",
    "progress.during": "In Progress",
    "progress.after": "Journey Complete",
    "progress.underway": "Your Umrah is underway",
    "progress.completed": "Your journey has been completed",
    "progress.daysToGo": "days to go",
    "progress.day": "Day",
    "progress.of": "of",
    "progress.starts": "Starts",
    // admin
    "admin.logout": "Log out",
    "admin.save": "Save changes",
    // spiritual tools
    "spiritual.title": "Spiritual Tools",
    "spiritual.subtitle": "Prayer, Qur'an and du'a — close at hand.",
    "sec.quran.title": "Qur'an",
    "sec.quran.desc": "Read with translation & audio",
    "sec.dua.title": "Du'as",
    "sec.dua.desc": "Supplications for your journey",
    // salah tracker
    "salah.title": "Salah Challenge",
    "salah.subtitle": "Private tracker · congregational prayers at the two sacred mosques.",
    "salah.madinah": "Madinah · Masjid an-Nabawi",
    "salah.makkah": "Makkah · Masjid al-Haram",
    "salah.travelday": "Travel Day · Oct 16",
    "salah.travelhint": "Tap the city where you prayed each salah.",
    "salah.note": "A prayer in Masjid an-Nabawi is better than a thousand prayers elsewhere, and a prayer in Masjid al-Haram is better still. (Bukhari · Muslim · Ibn Majah)",
    "salah.noteCite": "Bukhari 1190 · Muslim 1394 · Ibn Majah 1406",
    "salah.of": "of",
    "salah.prayers": "prayers",
    "salah.done": "marked",
    "salah.reset": "Reset tracker",
    "salah.resetTitle": "Reset your Salah tracker?",
    "salah.resetBody": "This clears every prayer you have marked. This cannot be undone.",
    // qur'an
    "quran.intro": "Read the Qur'an with transliteration, translation and audio. Your place is saved automatically.",
    "quran.surah": "Surah",
    "quran.juz": "Juz",
    "quran.search": "Search surah by name or number",
    "quran.resume": "Resume reading",
    "quran.ayahs": "ayahs",
    "quran.meccan": "Meccan",
    "quran.medinan": "Medinan",
    "quran.reciter": "Reciter",
    "quran.playSurah": "Play",
    "quran.pause": "Pause",
    "quran.loading": "Loading…",
    "quran.error": "Could not load. Please check your connection and try again.",
    "quran.retry": "Retry",
    "quran.juzLabel": "Juz",
    // du'a library
    "dua.intro": "A simple screen to read from while you make du'a. Where no specific du'a is prescribed, you may call upon Allah in any language for whatever good you need.",
    "dua.when": "When",
    "dua.source": "Source",
  },
  fr: {
    brand: "Maqam Journey",
    beginJourney: "Commencer votre voyage",
    "hero.welcome": "Bienvenue dans votre",
    "hero.brand": "Maqam Journey",
    latestUpdates: "Dernières actualités",
    checkHere: "Consultez ici avant de demander sur WhatsApp — les nouvelles mises à jour apparaissent toujours ici.",
    exploreJourney: "Votre voyage",
    exploreSubtitle: "Tout ce dont vous avez besoin, au même endroit.",
    back: "Retour",
    backToJourney: "Retour au voyage",
    viewOnMaps: "Itinéraire",
    call: "Appeler",
    whatsapp: "WhatsApp",
    open: "Ouvrir",
    download: "Télécharger",
    noFileYet: "Bientôt disponible",
    walkingDistance: "À pied du Haram",
    checkInInfo: "Arrivée",
    amenities: "Commodités à proximité",
    viewDetails: "Voir",
    "nav.home": "Accueil",
    "nav.itinerary": "Itinéraire",
    "nav.documents": "Documents",
    "nav.updates": "Actualités",
    "nav.support": "Assistance",
    "nav.maps": "Cartes",
    "nav.more": "Plus",
    "more.title": "Plus",
    "more.subtitle": "Tous les essentiels de votre voyage",
    "today.title": "Le voyage aujourd'hui",
    "today.day": "Jour",
    "today.before": "Votre voyage n'a pas encore commencé",
    "today.after": "Votre voyage est terminé",
    "sos.title": "Urgence SOS",
    "sos.hold": "Appuyez et maintenez 3 secondes",
    "sos.holding": "Maintenez…",
    "sos.ready": "Options d'urgence prêtes",
    "sos.callEmergency": "Appeler l'urgence Maqam",
    "sos.whatsappEmergency": "WhatsApp Urgence",
    "sos.shareLocation": "Partager ma position",
    "sos.guidance": "Conseils d'urgence",
    "sos.lost": "Séparé du groupe",
    "sos.lostBody": "Restez sur place si c'est sûr. Écrivez dans le groupe WhatsApp Maqam pour qu'un membre à proximité puisse aider, gardez la carte de l'hôtel visible et appelez votre responsable de groupe ou l'assistance Maqam.",
    "sos.medical": "Urgence médicale",
    "sos.medicalBody": "Appelez le 997 (Croissant-Rouge), le 911 (urgence unifiée) ou le 937 (ministère de la Santé), puis prévenez immédiatement l'équipe Maqam.",
    "sos.passport": "Problèmes de passeport",
    "sos.passportBody": "Contactez immédiatement l'équipe Maqam ; gardez une photo de votre passeport à portée de main.",
    "sos.transport": "Problèmes de transport",
    "sos.transportBody": "Appelez votre responsable de groupe et attendez dans un lieu sûr et visible.",
    "sos.reset": "Réinitialiser",
    "install.title": "Installer Maqam Journey",
    "install.body": "Ajoutez l'app à votre écran d'accueil pour un accès rapide pendant tout votre voyage.",
    "install.cta": "Installer",
    "install.later": "Plus tard",
    "priority.important": "Important",
    "priority.reminder": "Rappel",
    "priority.action": "Action requise",
    "priority.completed": "Terminé",
    "priority.new": "Nouveau",
    "priority.travel": "Mise à jour voyage",
    "status.draftTitle": "En préparation",
    "status.archivedTitle": "Voyage terminé",
    "status.future": "Revenez bientôt pour découvrir les prochains voyages Maqam.",
    "sec.travel.title": "Détails du voyage",
    "sec.travel.desc": "Vols, aéroports et arrivée",
    "sec.hotels.title": "Hôtels",
    "sec.hotels.desc": "Vos séjours à Médine et La Mecque",
    "sec.itinerary.title": "Itinéraire quotidien",
    "sec.itinerary.desc": "Votre programme jour par jour",
    "sec.umrah.title": "Guide de la Omra",
    "sec.umrah.desc": "Guide pas à pas et du'a",
    "sec.documents.title": "Documents",
    "sec.documents.desc": "Billets, visa et listes",
    "sec.maps.title": "Cartes et navigation",
    "sec.maps.desc": "Hôtels, points de rencontre",
    "sec.food.title": "Restauration et achats",
    "sec.food.desc": "Les essentiels près de vos hôtels",
    "sec.faq.title": "FAQ",
    "sec.faq.desc": "Réponses rapides aux questions",
    "sec.support.title": "Assistance",
    "sec.support.desc": "Contacts et aide d'urgence",
    "umrah.steps": "Guide pas à pas",
    "umrah.checklist": "Liste Ihram",
    "umrah.dos": "À faire",
    "umrah.donts": "À éviter",
    "umrah.dua": "Guide de Du'a numérique",
    "support.contacts": "Contacts clés",
    "support.emergency": "Numéros d'urgence",
    "support.lost": "Si vous êtes séparé du groupe",
    "documents.reminders": "Documents de voyage importants et rappels",
    "progress.before": "Préparation de votre voyage",
    "progress.during": "En cours",
    "progress.after": "Voyage terminé",
    "progress.underway": "Votre Omra est en cours",
    "progress.completed": "Votre voyage est terminé",
    "progress.daysToGo": "jours restants",
    "progress.day": "Jour",
    "progress.of": "sur",
    "progress.starts": "Départ",
    "sec.support.title": "Assistance",
    "sec.support.desc": "Contacts et aide d'urgence",
    "sec.guide.title": "Guide numérique de la Omra",
    "sec.guide.desc": "Lire, suivre Tawaf et Sa'i",
    "sec.flights.title": "Itinéraire de vol",
    "sec.flights.desc": "EgyptAir — aller et retour",
    "guide.title": "Guide numérique de la Omra",
    "guide.subtitle": "Votre compagnon serein, pas à pas, pour la Omra.",
    "guide.read": "Lire le guide",
    "guide.readDesc": "Ouvrir, feuilleter chaque page et zoomer",
    "guide.download": "Télécharger le guide",
    "guide.downloadDesc": "Enregistrer une copie hors ligne",
    "guide.page": "Page",
    "guide.of": "sur",
    "guide.tools": "Outils de rituel interactifs",
    "guide.toolsDesc": "Suivez votre Tawaf, Sa'i et vos étapes. La progression est enregistrée en privé sur cet appareil.",
    "guide.reset": "Réinitialiser la progression",
    "guide.resetTitle": "Réinitialiser votre progression ?",
    "guide.resetBody": "Cela efface vos circuits de Tawaf, vos longueurs de Sa'i et votre liste de rituels. Cette action est irréversible.",
    "guide.cancel": "Annuler",
    "tawaf.title": "Compteur de Tawaf",
    "tawaf.help": "Touchez un cercle à chaque circuit terminé, au retour à la Pierre noire.",
    "tawaf.circuit": "Circuit",
    "tawaf.completed": "sur 7 circuits terminés",
    "tawaf.done": "Tawaf terminé — 7 circuits. Qu'Allah l'accepte.",
    "sai.title": "Compteur de Sa'i",
    "sai.help": "Touchez chaque longueur terminée. Le Sa'i commence à Safa et se termine à Marwa.",
    "sai.length": "Longueur",
    "sai.completed": "sur 7 longueurs terminées",
    "sai.finish": "Le Sa'i se termine à Marwa",
    "sai.done": "Sa'i terminé — vous avez fini à Marwa.",
    "checklist.title": "Liste des rituels de la Omra",
    "checklist.help": "Touchez chaque étape terminée.",
    "checklist.ihram": "Ihram et intention (niyyah)",
    "checklist.tawaf": "Tawaf — sept circuits",
    "checklist.rakahs": "Deux rak'ahs après le Tawaf",
    "checklist.zamzam": "Boire l'eau de Zamzam",
    "checklist.sai": "Sa'i — sept longueurs",
    "checklist.hair": "Couper les cheveux (halq / taqsir)",
    "checklist.hairNote": "Votre Omra s'achève après la coupe des cheveux.",
    "checklist.complete": "Omra terminée — qu'Allah l'accepte.",
    "flights.title": "Itinéraire de vol",
    "flights.subtitle": "Vos vols EgyptAir en un coup d'œil.",
    "flights.outbound": "Aller",
    "flights.return": "Retour",
    "flights.depart": "Départ",
    "flights.arrive": "Arrivée",
    "flights.nextDay": "Jour suivant",
    "flights.flight": "Vol",
    "flights.localTimes": "Toutes les heures sont locales à chaque aéroport.",
    "itinerary.preTrip": "Avant le départ",
    "flights.airportMeet": "Point de rencontre à l'aéroport",
    "worship.title": "Profitez au mieux de votre temps libre",
    "travel.departures": "Instructions de départ",
    "maps.laundry": "Services de blanchisserie recommandés",
    "sec.janazah.title": "Salatul Janazah",
    "sec.janazah.desc": "La prière funéraire, étape par étape",
    "janazah.title": "Salatul Janazah (prière funéraire)",
    "janazah.open": "Guide Salatul Janazah",
    "food.restaurants": "Restaurants (liste Google Maps)",
    "food.cafes": "Cafés (liste Google Maps)",
    "prayer.title": "Heures de prière",
    "prayer.madinah": "Médine",
    "prayer.makkah": "La Mecque",
    "prayer.madinahTitle": "Heures de prière — Médine",
    "prayer.makkahTitle": "Heures de prière — La Mecque",
    "prayer.method": "Umm al-Qura · heure locale",
    "prayer.fajr": "Fajr",
    "prayer.sunrise": "Lever du soleil",
    "prayer.dhuhr": "Dhuhr",
    "prayer.asr": "Asr",
    "prayer.maghrib": "Maghrib",
    "prayer.isha": "Isha",
    "prayer.next": "Prochaine",
    "prayer.in": "dans",
    "prayer.updated": "Mis à jour",
    "prayer.error": "Les heures de prière sont temporairement indisponibles. Vérifiez votre connexion et réessayez.",
    "prayer.retry": "Réessayer",
    "admin.logout": "Se déconnecter",
    "admin.save": "Enregistrer",
    "spiritual.title": "Outils spirituels",
    "spiritual.subtitle": "Prière, Coran et du'a — à portée de main.",
    "sec.quran.title": "Coran",
    "sec.quran.desc": "Lecture avec traduction et audio",
    "sec.dua.title": "Du'as",
    "sec.dua.desc": "Invocations pour votre voyage",
    "salah.title": "Défi Salah",
    "salah.subtitle": "Suivi privé · prières en congrégation dans les deux mosquées sacrées.",
    "salah.madinah": "Médine · Masjid an-Nabawi",
    "salah.makkah": "La Mecque · Masjid al-Haram",
    "salah.travelday": "Jour de voyage · 16 oct.",
    "salah.travelhint": "Touchez la ville où vous avez prié chaque salah.",
    "salah.note": "Une prière à Masjid an-Nabawi vaut mieux que mille prières ailleurs, et une prière à Masjid al-Haram vaut davantage encore. (Boukhari · Mouslim · Ibn Majah)",
    "salah.noteCite": "Boukhari 1190 · Mouslim 1394 · Ibn Majah 1406",
    "salah.of": "sur",
    "salah.prayers": "prières",
    "salah.done": "marquées",
    "salah.reset": "Réinitialiser le suivi",
    "salah.resetTitle": "Réinitialiser votre suivi Salah ?",
    "salah.resetBody": "Cela efface toutes les prières marquées. Cette action est irréversible.",
    "quran.intro": "Lisez le Coran avec translittération, traduction et audio. Votre position est enregistrée automatiquement.",
    "quran.surah": "Sourate",
    "quran.juz": "Juz",
    "quran.search": "Rechercher une sourate par nom ou numéro",
    "quran.resume": "Reprendre la lecture",
    "quran.ayahs": "versets",
    "quran.meccan": "Mecquoise",
    "quran.medinan": "Médinoise",
    "quran.reciter": "Récitateur",
    "quran.playSurah": "Lire",
    "quran.pause": "Pause",
    "quran.loading": "Chargement…",
    "quran.error": "Chargement impossible. Vérifiez votre connexion et réessayez.",
    "quran.retry": "Réessayer",
    "quran.juzLabel": "Juz",
    "dua.intro": "Un écran simple à lire pendant vos invocations. Lorsqu'aucune du'a précise n'est prescrite, vous pouvez invoquer Allah dans n'importe quelle langue pour tout bien dont vous avez besoin.",
    "dua.when": "Quand",
    "dua.source": "Source",
  },
  sw: {
    brand: "Maqam Journey",
    beginJourney: "Anza Safari Yako",
    "hero.welcome": "Karibu Kwenye",
    "hero.brand": "Maqam Journey",
    latestUpdates: "Taarifa za Hivi Karibuni",
    checkHere: "Angalia hapa kwanza kabla ya kuuliza kwenye WhatsApp — taarifa mpya huonekana hapa daima.",
    exploreJourney: "Safari Yako",
    exploreSubtitle: "Kila unachohitaji, mahali pamoja.",
    back: "Rudi",
    backToJourney: "Rudi kwenye Safari",
    viewOnMaps: "Maelekezo",
    call: "Piga simu",
    whatsapp: "WhatsApp",
    open: "Fungua",
    download: "Pakua",
    noFileYet: "Inakuja hivi karibuni",
    walkingDistance: "Kutembea hadi Haram",
    checkInInfo: "Kuingia (Check-in)",
    amenities: "Huduma za karibu",
    viewDetails: "Tazama",
    "nav.home": "Nyumbani",
    "nav.itinerary": "Ratiba",
    "nav.documents": "Nyaraka",
    "nav.updates": "Taarifa",
    "nav.support": "Msaada",
    "nav.maps": "Ramani",
    "nav.more": "Zaidi",
    "more.title": "Zaidi",
    "more.subtitle": "Mahitaji yote ya safari yako",
    "today.title": "Safari ya Leo",
    "today.day": "Siku",
    "today.before": "Safari yako bado haijaanza",
    "today.after": "Safari yako imekamilika",
    "sos.title": "Dharura SOS",
    "sos.hold": "Bonyeza na ushikilie kwa sekunde 3",
    "sos.holding": "Endelea kushikilia…",
    "sos.ready": "Chaguzi za dharura ziko tayari",
    "sos.callEmergency": "Piga simu ya Dharura Maqam",
    "sos.whatsappEmergency": "WhatsApp Dharura",
    "sos.shareLocation": "Shiriki Mahali Nilipo",
    "sos.guidance": "Mwongozo wa Dharura",
    "sos.lost": "Kupotea kutoka kwa kundi",
    "sos.lostBody": "Baki ulipo ikiwa ni salama. Tuma ujumbe kwenye kundi la WhatsApp la Maqam ili mwanachama aliye karibu akusaidie, weka kadi ya hoteli yako ionekane, na mpigie simu Kiongozi wa Kundi au msaada wa Maqam.",
    "sos.medical": "Dharura ya kiafya",
    "sos.medicalBody": "Piga 997 (Hilali Nyekundu), 911 (dharura ya pamoja) au 937 (Wizara ya Afya), kisha arifu timu ya Maqam mara moja.",
    "sos.passport": "Matatizo ya pasipoti",
    "sos.passportBody": "Wasiliana na timu ya Maqam mara moja; weka picha ya pasipoti yako tayari.",
    "sos.transport": "Matatizo ya usafiri",
    "sos.transportBody": "Mpigie simu Kiongozi wa Kundi lako na usubiri mahali salama na panapoonekana.",
    "sos.reset": "Anza upya",
    "install.title": "Sakinisha Maqam Journey",
    "install.body": "Iongeze kwenye skrini yako ya nyumbani kwa ufikiaji wa haraka wakati wote wa safari yako.",
    "install.cta": "Sakinisha",
    "install.later": "Si sasa",
    "priority.important": "Muhimu",
    "priority.reminder": "Kumbusho",
    "priority.action": "Hatua Inahitajika",
    "priority.completed": "Imekamilika",
    "priority.new": "Mpya",
    "priority.travel": "Taarifa ya Safari",
    "status.draftTitle": "Inaandaliwa",
    "status.archivedTitle": "Safari Imehitimishwa",
    "status.future": "Tafadhali rudi hivi karibuni kwa safari zijazo za Maqam.",
    "sec.travel.title": "Taarifa za Usafiri",
    "sec.travel.desc": "Safari za ndege, viwanja & kuwasili",
    "sec.hotels.title": "Hoteli",
    "sec.hotels.desc": "Malazi yako Madina & Makka",
    "sec.itinerary.title": "Ratiba ya Kila Siku",
    "sec.itinerary.desc": "Mpangilio wako siku kwa siku",
    "sec.umrah.title": "Mwongozo wa Umrah",
    "sec.umrah.desc": "Mwongozo hatua kwa hatua & du'a",
    "sec.documents.title": "Nyaraka",
    "sec.documents.desc": "Tiketi, visa & orodha",
    "sec.maps.title": "Ramani & Mwelekeo",
    "sec.maps.desc": "Hoteli, mikutano & sehemu za kuchukua",
    "sec.food.title": "Chakula & Ununuzi",
    "sec.food.desc": "Mahitaji ya msingi karibu na hoteli zako",
    "sec.faq.title": "Maswali",
    "sec.faq.desc": "Majibu ya haraka ya maswali ya kawaida",
    "sec.support.title": "Msaada",
    "sec.support.desc": "Mawasiliano & msaada wa dharura",
    "sec.guide.title": "Mwongozo wa Kidijitali wa Umrah",
    "sec.guide.desc": "Soma, fuatilia Tawaf & Sa'i",
    "sec.flights.title": "Ratiba ya Ndege",
    "sec.flights.desc": "EgyptAir — kwenda & kurudi",
    "guide.title": "Mwongozo wa Kidijitali wa Umrah",
    "guide.subtitle": "Mwenzako mtulivu, hatua kwa hatua, kwa Umrah.",
    "guide.read": "Soma Mwongozo",
    "guide.readDesc": "Fungua, pitia kila ukurasa na ukuze",
    "guide.download": "Pakua Mwongozo",
    "guide.downloadDesc": "Hifadhi nakala kwa matumizi bila mtandao",
    "guide.page": "Ukurasa",
    "guide.of": "kati ya",
    "guide.tools": "Zana Shirikishi za Ibada",
    "guide.toolsDesc": "Fuatilia Tawaf, Sa'i na hatua zako za Umrah. Maendeleo huhifadhiwa kwa faragha kwenye kifaa hiki.",
    "guide.reset": "Anza maendeleo upya",
    "guide.resetTitle": "Anza maendeleo yako upya?",
    "guide.resetBody": "Hii itafuta mizunguko yako ya Tawaf, urefu wa Sa'i na orodha ya ibada. Haiwezi kutenduliwa.",
    "guide.cancel": "Ghairi",
    "tawaf.title": "Kihesabu cha Tawaf",
    "tawaf.help": "Gusa duara kila unapokamilisha mzunguko na kurudi kwenye Jiwe Jeusi.",
    "tawaf.circuit": "Mzunguko",
    "tawaf.completed": "kati ya mizunguko 7 iliyokamilika",
    "tawaf.done": "Tawaf imekamilika — mizunguko 7. Allah aikubali.",
    "sai.title": "Kihesabu cha Sa'i",
    "sai.help": "Gusa kila urefu unapoukamilisha. Sa'i huanza Safa na kumalizia Marwa.",
    "sai.length": "Urefu",
    "sai.completed": "kati ya urefu 7 uliokamilika",
    "sai.finish": "Sa'i humalizia Marwa",
    "sai.done": "Sa'i imekamilika — ulimalizia Marwa.",
    "checklist.title": "Orodha ya Ibada za Umrah",
    "checklist.help": "Gusa kila hatua unapoikamilisha.",
    "checklist.ihram": "Ihram & nia (niyyah)",
    "checklist.tawaf": "Tawaf — mizunguko saba",
    "checklist.rakahs": "Rakaa mbili baada ya Tawaf",
    "checklist.zamzam": "Kunywa maji ya Zamzam",
    "checklist.sai": "Sa'i — urefu saba",
    "checklist.hair": "Kunyoa/kukata nywele (halq / taqsir)",
    "checklist.hairNote": "Umrah yako hukamilika ukikata nywele zako.",
    "checklist.complete": "Umrah imekamilika — Allah aikubali.",
    "flights.title": "Ratiba ya Ndege",
    "flights.subtitle": "Safari zako za EgyptAir kwa mtazamo mmoja.",
    "flights.outbound": "Kwenda",
    "flights.return": "Kurudi",
    "flights.depart": "Inaondoka",
    "flights.arrive": "Inawasili",
    "flights.nextDay": "Siku inayofuata",
    "flights.flight": "Safari ya ndege",
    "flights.localTimes": "Nyakati zote ni za eneo la kila kiwanja cha ndege.",
    "itinerary.preTrip": "Kabla ya Kusafiri",
    "flights.airportMeet": "Sehemu ya kukutania uwanjani",
    "worship.title": "Tumia Vyema Muda Wako Wa Ziada",
    "travel.departures": "Maelekezo ya Kuondoka",
    "maps.laundry": "Huduma za Kufua Zinazopendekezwa",
    "sec.janazah.title": "Salatul Janazah",
    "sec.janazah.desc": "Sala ya jeneza, hatua kwa hatua",
    "janazah.title": "Salatul Janazah (Sala ya Jeneza)",
    "janazah.open": "Mwongozo wa Salatul Janazah",
    "food.restaurants": "Migahawa (orodha ya Google Maps)",
    "food.cafes": "Mikahawa ya kahawa (orodha ya Google Maps)",
    "prayer.title": "Nyakati za Sala",
    "prayer.madinah": "Madina",
    "prayer.makkah": "Makka",
    "prayer.madinahTitle": "Nyakati za Sala — Madina",
    "prayer.makkahTitle": "Nyakati za Sala — Makka",
    "prayer.method": "Umm al-Qura · saa za Saudia",
    "prayer.fajr": "Alfajiri",
    "prayer.sunrise": "Macheo",
    "prayer.dhuhr": "Adhuhuri",
    "prayer.asr": "Alasiri",
    "prayer.maghrib": "Magharibi",
    "prayer.isha": "Isha",
    "prayer.next": "Inayofuata",
    "prayer.in": "baada ya",
    "prayer.updated": "Imesasishwa",
    "prayer.error": "Nyakati za sala hazipatikani kwa muda. Tafadhali angalia muunganisho wako na ujaribu tena.",
    "prayer.retry": "Jaribu tena",
    "umrah.steps": "Mwongozo Hatua kwa Hatua",
    "umrah.checklist": "Orodha ya Ihram",
    "umrah.dos": "Yafanye",
    "umrah.donts": "Yaepuke",
    "umrah.dua": "Mwongozo wa Kidijitali wa Du'a",
    "support.contacts": "Mawasiliano Muhimu",
    "support.emergency": "Namba za Dharura",
    "support.lost": "Ukitengana na Kundi",
    "documents.reminders": "Nyaraka Muhimu za Safari & Vikumbusho",
    "progress.before": "Kujiandaa kwa Safari Yako",
    "progress.during": "Inaendelea",
    "progress.after": "Safari Imekamilika",
    "progress.underway": "Umrah yako inaendelea",
    "progress.completed": "Safari yako imekamilika",
    "progress.daysToGo": "siku zilizobaki",
    "progress.day": "Siku",
    "progress.of": "kati ya",
    "progress.starts": "Inaanza",
    "admin.logout": "Toka",
    "admin.save": "Hifadhi mabadiliko",
    "spiritual.title": "Zana za Kiroho",
    "spiritual.subtitle": "Sala, Qur'an na du'a — karibu nawe.",
    "sec.quran.title": "Qur'an",
    "sec.quran.desc": "Soma pamoja na tafsiri & sauti",
    "sec.dua.title": "Du'a",
    "sec.dua.desc": "Dua kwa ajili ya safari yako",
    "salah.title": "Changamoto ya Sala",
    "salah.subtitle": "Kifuatiliaji cha faragha · sala za jamaa katika misikiti miwili mitukufu.",
    "salah.madinah": "Madina · Masjid an-Nabawi",
    "salah.makkah": "Makka · Masjid al-Haram",
    "salah.travelday": "Siku ya Safari · 16 Okt",
    "salah.travelhint": "Gusa mji ulioswali kila sala.",
    "salah.note": "Sala katika Masjid an-Nabawi ni bora kuliko sala elfu moja pengine, na sala katika Masjid al-Haram ni bora zaidi. (Bukhari · Muslim · Ibn Majah)",
    "salah.noteCite": "Bukhari 1190 · Muslim 1394 · Ibn Majah 1406",
    "salah.of": "kati ya",
    "salah.prayers": "sala",
    "salah.done": "zimewekwa alama",
    "salah.reset": "Anza kifuatiliaji upya",
    "salah.resetTitle": "Anza kifuatiliaji chako cha Sala upya?",
    "salah.resetBody": "Hii itafuta kila sala uliyoiweka alama. Haiwezi kutenduliwa.",
    "quran.intro": "Soma Qur'an pamoja na matamshi (translittration), tafsiri na sauti. Nafasi yako huhifadhiwa kiotomatiki.",
    "quran.surah": "Sura",
    "quran.juz": "Juzuu",
    "quran.search": "Tafuta sura kwa jina au namba",
    "quran.resume": "Endelea kusoma",
    "quran.ayahs": "aya",
    "quran.meccan": "Ya Makka",
    "quran.medinan": "Ya Madina",
    "quran.reciter": "Msomaji",
    "quran.playSurah": "Cheza",
    "quran.pause": "Simamisha",
    "quran.loading": "Inapakia…",
    "quran.error": "Imeshindikana kupakia. Tafadhali angalia muunganisho wako na ujaribu tena.",
    "quran.retry": "Jaribu tena",
    "quran.juzLabel": "Juzuu",
    "dua.intro": "Skrini rahisi ya kusoma unapofanya du'a. Pale ambapo hakuna du'a maalum iliyowekwa, unaweza kumwomba Allah kwa lugha yoyote kwa kheri yoyote unayohitaji.",
    "dua.when": "Wakati",
    "dua.source": "Chanzo",
  },

};
